import camisetaArg86L from "../assets/images/home/camisetas/camisetaArg86L.webp"
import camisetaArg86V from "../assets/images/home/camisetas/camisetaArg86V.webp"
import camisetaArg86LL from "../assets/images/home/camisetas/camisetaArg86LL.webp"
import camisetaBra02L from "../assets/images/home/camisetas/camisetaBra02L.webp"
import camisetaBra02V from "../assets/images/home/camisetas/camisetaBra02V.webp"
import camisetaBra02LL from "../assets/images/home/camisetas/camisetaBra02LL.webp"
import camisetaFra98L from "../assets/images/home/camisetas/camisetaFra98L.webp"
import camisetaFra98V from "../assets/images/home/camisetas/camisetaFra98V.webp"
import camisetaFra98LL from "../assets/images/home/camisetas/camisetaFra98LL.webp"
import camisetaHol88L from "../assets/images/home/camisetas/camisetaHol88L.webp"
import camisetaHol88V from "../assets/images/home/camisetas/camisetaHol88V.webp"
import camisetaHol88LL from "../assets/images/home/camisetas/camisetaHol88LL.webp"
import camisetaAle90L from "../assets/images/home/camisetas/camisetaAle90L.webp"
import camisetaAle90VL from "../assets/images/home/camisetas/camisetaAle90VL.webp"
import camisetaAle90LL from "../assets/images/home/camisetas/camisetaAle90LL.webp"
import camisetaBar10L from "../assets/images/home/camisetas/camisetaBar10L.webp"
import camisetaBar10V from "../assets/images/home/camisetas/camisetaBar10V.webp"
import camisetaBar10LL from "../assets/images/home/camisetas/camisetaBar10LL.webp"
import camisetaBar10VL from "../assets/images/home/camisetas/camisetaBar10VL.webp"
import camisetaRma02L from "../assets/images/home/camisetas/camisetaRma02L.webp"
import camisetaRma02V from "../assets/images/home/camisetas/camisetaRma02V.webp"
import camisetaRma02LL from "../assets/images/home/camisetas/camisetaRma02LL.webp"
import camisetaRma02VL from "../assets/images/home/camisetas/camisetaRma02VL.webp"
import camisetaJuv96L from "../assets/images/home/camisetas/camisetaJuv96L.webp"
import camisetaJuv96V from "../assets/images/home/camisetas/camisetaJuv96V.webp"
import camisetaJuv96VL from "../assets/images/home/camisetas/camisetaJuv96VL.webp"
import camisetaJuv96A from "../assets/images/home/camisetas/camisetaJuv96A.webp"
import camisetaAcm06L from "../assets/images/home/camisetas/camisetaAcm06L.webp"
import camisetaAcm06V from "../assets/images/home/camisetas/camisetaAcm06V.webp"
import camisetaAcm06VN from "../assets/images/home/camisetas/camisetaAcm06VN.webp"
import camisetaAcm06LL from "../assets/images/home/camisetas/camisetaAcm06LL.webp"
import camisetaAcm06VL from "../assets/images/home/camisetas/camisetaAcm06VL.webp"
import camisetaAcm06VNL from "../assets/images/home/camisetas/camisetaAcm06VNL.webp"
import camisetaArs05L from "../assets/images/home/camisetas/camisetaArs05L.webp"
import camisetaArs05LL from "../assets/images/home/camisetas/camisetaArs05LL.webp"
import camisetaMun06L from "../assets/images/home/camisetas/camisetaMun06L.webp"
import camisetaMun06V from "../assets/images/home/camisetas/camisetaMun06V.webp"
import camisetaMun06LA from "../assets/images/home/camisetas/camisetaMun06LA.webp"
import camisetaMun06LL from "../assets/images/home/camisetas/camisetaMun06LL.webp"
import camisetaMun06VL from "../assets/images/home/camisetas/camisetaMun06VL.webp"
import camisetaMun06LAL from "../assets/images/home/camisetas/camisetaMun06LAL.webp"
import camisetaLiv93L from "../assets/images/home/camisetas/camisetaLiv93L.webp"
import camisetaLiv93V from "../assets/images/home/camisetas/camisetaLiv93V.webp"
import camisetaLiv93LL from "../assets/images/home/camisetas/camisetaLiv93LL.webp"
import camisetaLiv93VL from "../assets/images/home/camisetas/camisetaLiv93VL.webp"
import camisetaRom01L from "../assets/images/home/camisetas/camisetaRom01L.webp"
import camisetaRom01V from "../assets/images/home/camisetas/camisetaRom01V.webp"
import camisetaRom01LL from "../assets/images/home/camisetas/camisetaRom01LL.webp"
import camisetaRom01VL from "../assets/images/home/camisetas/camisetaRom01VL.webp"
import camisetaBoc96L from "../assets/images/home/camisetas/camisetaBoc96L.webp"
import camisetaBoc96V from "../assets/images/home/camisetas/camisetaBoc96V.webp"
import camisetaBoc96LL from "../assets/images/home/camisetas/camisetaBoc96LL.webp"
import camisetaBoc99L from "../assets/images/home/camisetas/camisetaBoc99L.webp"
import camisetaBoc99V from "../assets/images/home/camisetas/camisetaBoc99V.webp"
import camisetaBoc99VB from "../assets/images/home/camisetas/camisetaBoc99VB.webp"
import camisetaRiv96L from "../assets/images/home/camisetas/camisetaRiv96L.webp"
import camisetaRiv96LL from "../assets/images/home/camisetas/camisetaRiv96LL.webp"
import camisetaRiv18L from "../assets/images/home/camisetas/camisetaRiv18L.webp"
import camisetaEsp10L from "../assets/images/home/camisetas/camisetaEsp10L.webp"
import camisetaEsp10V from "../assets/images/home/camisetas/camisetaEsp10V.webp"
import camisetaEsp10VL from "../assets/images/home/camisetas/camisetaEsp10VL.webp"
import camisetaEsp10LA from "../assets/images/home/camisetas/camisetaEsp10LA.webp"

const products = [
  {
    id: ['74c94344-cb7a-400f-aeba-9699f6cddb2a', '2d1f7463-be89-4be5-be64-be83ccdbd1a0', '60d5ccc4-6414-4e36-9dd2-94d16afff577'],
    name: "Argentina 1986",
    description: "La camiseta de Maradona en México '86: La Mano de Dios y el Gol del Siglo",
    price: [84400, 84400, 87000],
    badge: "Histórica",
    variants: ["Local", "Visitante", "Local M.larga"],
    img: [camisetaArg86L, camisetaArg86V, camisetaArg86LL]
  },
  {
    id: ['62261e1c-64a4-4dfb-98c3-c6331eed283d', 'c08527c4-32d2-483f-8ab6-495b3a5bf984', '6512c787-6de2-4dfe-93df-c7920cff61ae'],
    name: "Brasil 2002",
    description: "Ronaldo, Ronaldinho y Rivaldo deslumbraron al mundo y le dieron a Brasil su quinta estrella en Corea-Japón",
    price: [84400, 84400, 87000],
    badge: "Épica",
    variants: ["Local", "Visitante", "Local M.larga"],
    img: [camisetaBra02L, camisetaBra02V, camisetaBra02LL]
  },
  {
    id: ['0b4b99fd-7fbf-4a30-9b52-1c5037fdead1', 'eebeef69-cc7e-45e8-aff7-b68ae9684e05', 'de76b77d-1b4f-4578-b99d-b9dc54a3fc70'],
    name: "Francia 1998",
    description: "Zidane, Deschamps y Henry alzaron la Copa del Mundo en el Stade de France",
    price: [84400, 84400, 87000],
    badge: "Histórica",
    variants: ["Local", "Visitante", "Local M.larga"],
    img: [camisetaFra98L, camisetaFra98V, camisetaFra98LL]
  },
  {
    id: ['30f12884-fc87-4ea8-8031-8352a239387e', '1c277047-de83-42e5-9f80-ce97910340da', '5530cd6f-4f61-4434-b57e-34b816a5708a'],
    name: "Holanda 1988",
    description: "El icónico diseño naranja con Gullit y Van Basten campeones de la Euro",
    price: [84400, 84400, 87000],
    badge: "Retro",
    variants: ["Local", "Visitante", "Local M.larga"],
    img: [camisetaHol88L, camisetaHol88V, camisetaHol88LL]
  },
  {
    id: ['63b4ecc0-9902-402f-9d11-f8f529ac3299','40238576-0eee-4b10-9118-7aee501a412a', 'a005a1e0-f72a-4ceb-8d17-2c58cbd07d91'],
    name: "Alemania 1990",
    description: "Matthäus y Klinsmann lideraron a Alemania a su tercera Copa del Mundo",
    price: [84400, 87000, 87000],
    badge: "Clásico",
    variants: ["Local", "Local M.larga", "Visitante M.larga"],
    img: [camisetaAle90L, camisetaAle90LL, camisetaAle90VL]
  },
  {
    id: ['bde98c43-324b-40bb-a8c4-781bbe1ec3d9', '582748e5-aead-4712-911d-ac480ef0aca5', '142e7b60-82d3-40b7-98d7-15ed91c16dd8', 'a7be0ff8-6a86-4960-af98-57c48953298a'],
    name: "Barcelona 2010",
    description: "El Barça de Guardiola con Messi, Iniesta y Xavi: el equipo perfecto del siglo XXI",
    price: [84400, 84400, 87000, 87000],
    badge: "Épica",
    variants: ["Local", "Visitante", "Local M.larga", "Visitante M.larga"],
    img: [camisetaBar10L, camisetaBar10V, camisetaBar10LL, camisetaBar10VL]
  },
  {
    id: ['814d98ff-15f2-49de-9a57-083496e89de2', '209675c6-9f8d-46fa-8982-fba9399c3e93', 'b7713150-e658-4745-9977-ddad51bae71c', '2b0587fb-1cf6-45ab-8871-bf6385f4b237'],
    name: "Real Madrid 2002",
    description: "Zidane, Ronaldo, Figo y Beckham: los Galácticos ganando la Novena en Glasgow",
    price: [84400, 84400, 87000, 87000],
    badge: "Legendaria",
    variants: ["Local", "Visitante", "Local M.larga", "Visitante M.larga"],
    img: [camisetaRma02L, camisetaRma02V, camisetaRma02LL, camisetaRma02VL]
  },
  {
    id: ['0dfbfc4a-3641-47fd-8685-99a93cb15f21', 'df3e292c-52d6-4758-89fe-8013b89ebc2d', 'd1611823-d7ff-484d-b0f1-a614b7d67042', 'c7b14ee2-0f99-4504-857f-a17f810fd8c1'],
    name: "Juventus 1996",
    description: "Del Piero y Vialli alzaron la Champions con la Vecchia Signora tras una final intensa",
    price: [84400, 84400, 87000, 84400],
    badge: "Retro",
    variants: ["Local", "Visitante", "Visitante M.larga", 'Alternativa'],
    img: [camisetaJuv96L, camisetaJuv96V, camisetaJuv96VL, camisetaJuv96A]
  },
  {
    id: ['8a2cd063-ff09-4910-a21f-620f6ccbc6f8', '212c821a-c54d-494c-a101-4598b8bac130', '0bca23fc-762e-47df-bc09-354c204978fd', '238650bd-5775-4b7d-910f-c4c3b2f28be4', 'c69ca862-89e0-4d7e-ba29-7f203d60028b', '8dc8496c-8708-43b0-a32a-21dc51d748f5'],
    name: "AC Milan 2006",
    description: "Kaká brillaba en un Milan de leyenda, camino a su última Champions bajo el mando de Ancelotti",
    price: [84400, 84400, 84400, 87000, 87000, 87000],
    badge: "Élite",
    variants: ["Local", "Visitante", "Visitante Negra", "Local M.larga", "Visitante M.larga", "Visitante Negra M.larga"],
    img: [camisetaAcm06L, camisetaAcm06V, camisetaAcm06VN, camisetaAcm06LL, camisetaAcm06VL, camisetaAcm06VNL]
  },
  {
    id: ['5c3129c3-1d39-4850-b372-1f964f85708a', '0092336a-55e0-4369-a36a-1e5cc7bc627e'],
    name: "Arsenal 2005",
    description: "Henry, Bergkamp y Pires convirtieron Highbury en un templo. Una era inolvidable con clase y velocidad",
     price: [84400, 87000],
    badge: "Premier",
    variants: ["Local", "Local M.larga"],
    img: [camisetaArs05L, camisetaArs05LL]
  },
  {
    id: ['ab8fee64-e055-44e6-bd3b-1fc84f2922a2', '343f74f0-861e-4a32-91b4-4d6f59c963ab', 'dca8e03a-0174-43d0-8846-af1d2e97d903', '61aaf316-b281-4dd3-849a-a74acdde4e0a', 'f147a58f-02f1-45ba-8bd2-5fb6d216b918', '2ad937e7-e7f4-4e11-8784-6ba47c78e117'],
    name: "Manchester United 2007",
    description: "Cristiano Ronaldo, Rooney y Giggs conquistaron Inglaterra y Europa bajo el mando de Ferguson",
    price: [84400, 84400, 84400, 87000, 87000, 87000],
    badge: "Gloriosa",
    variants: ["Local", "Visitante", "Local Leyenda", "Local M.larga", "Visitante M.larga", "Local Leyenda M.larga",],
    img: [camisetaMun06L, camisetaMun06V, camisetaMun06LA, camisetaMun06LL, camisetaMun06VL, camisetaMun06LAL]
  },
  {
    id: ['857e2930-6623-4ffe-ba57-55f5847676f8', '74e6e21f-71ed-4b36-9b7b-4aa9cfb4e247', '7bf86697-08aa-469a-b4ed-78a40cac3bae', '697c0359-db4d-40d0-96ee-6a4e42ccf167'],
    name: "Liverpool 1993",
    description: "Los 'Reds' renovaban su identidad en los 90, con Fowler y McManaman como símbolos del nuevo ciclo",
    price: [84400, 84400, 87000, 87000],
    badge: "Retro",
    variants: ["Local", "Visitante", "Local M.larga", "Visitante M.larga"],
    img: [camisetaLiv93L, camisetaLiv93V, camisetaLiv93LL, camisetaLiv93VL]
  },
  {
    id: ['d88c3c68-3562-4f24-b9ae-41b2339e3537', '88c32744-3540-47ac-819e-7f872f6f7c40', '1f87cbfb-e979-4fd7-9171-b70029bdea68', '869cbd18-b39a-40ed-b6c6-d5da3b7beee1'],
    name: "Roma 2001",
    description: "Batistuta y Totti le dieron a la Loba su último Scudetto en un año inolvidable",
    price: [84400, 84400, 87000, 87000],
    badge: "Pasional",
    variants: ["Local", "Visitante", "Local M.larga", "Visitante M.larga"],
    img: [camisetaRom01L, camisetaRom01V, camisetaRom01LL, camisetaRom01VL]
  },
  {
    id: ['10f3e646-b251-49f7-8a51-4377edde2e87', '518beff1-d30e-4f7c-bc92-c2e3b5a0e771', 'b3f78bda-544e-46dc-93f3-27277d226b3e'],
    name: "Boca Juniors 1996",
    description: "El comienzo de una era con Maradona de vuelta, y los primeros pasos del equipo que lo ganaría todo",
    price: [84400, 84400, 87000],
    badge: "Emotiva",
    variants: ["Local", "Visitante", "Local M.larga"],
    img: [camisetaBoc96L, camisetaBoc96V, camisetaBoc96LL]
  },
  {
    id: ['6738a946-5ed5-492a-93ce-2e4f1b096544', 'bf7e794a-d494-4bbf-966e-faa9667751c1', '96834e19-d6fe-4539-ab32-07244013e828'],
    name: "Boca Juniors 1999",
    description: "La Copa Libertadores volvió a La Bombonera: Riquelme y Palermo marcaban el inicio de la gloria",
    price: [84400, 84400, 84400],
    badge: "Continental",
    variants: ["Local", "Visitante", "Visitante Blanca"],
    img: [camisetaBoc99L, camisetaBoc99V, camisetaBoc99VB],
  },
  {
    id: ['416e7c64-0e4d-4f41-bc5d-a37daedc9db4', '2fa40d3d-c624-4aaa-9322-809fc3c587ed'],
    name: "River Plate 1996",
    description: "Francescoli, Ortega y Crespo ganaron la Libertadores. Un clásico inolvidable",
    price: [84400, 87000],
    badge: "Histórica",
    variants: ["Local", "Local M.larga"],
    img: [camisetaRiv96L, camisetaRiv96LL]
  },
  {
    id: ['00494e25-9906-4b22-ae81-6c79c6d1020a'],
    name: "River Plate 2018",
    description: "El triunfo en Madrid ante Boca. La más recordada por toda una generación",
    price: [84400],
    badge: "Épica",
    variants: ["Local"],
    img: [camisetaRiv18L]
  },
  {
    id: ['ce3b975d-229c-4abc-a83f-18c111b598ad', '1d659a6f-5880-43b9-9158-841dd22d3e25', 'd43ee87e-366d-4f25-8fc8-c6a0c3e7e0e6', '0276e1be-1493-4e71-8904-c3d70b10f26e'],
    name: "España 2010",
    description: "Xavi, Iniesta y Casillas llevaron a La Roja a su primer Mundial en Sudáfrica",
    price: [84400, 84400, 87000, 84400],
    badge: "Campeona",
    variants: ["Local", "Visitante", "Visitante M.larga", "Local Arquero"],
    img: [camisetaEsp10L, camisetaEsp10V, camisetaEsp10VL, camisetaEsp10LA],
  }
];

export default products;